import { OneTrust } from '../model/onetrust'

export function createOptanonWrapper(
  resolve: (onetrust: OneTrust) => void,
  reject: (error: Error) => void
) {
  window.OptanonWrapper = () => {
    const ot = window.OneTrust
    if (!ot) {
      return reject(
        new Error(
          'OneTrust is not defined, when OptanonWrapper is called. This usually means that the OneTrust script was not loaded correctly or is not available in the global scope.'
        )
      )
    }
    return resolve(ot)
  }
}
